const Status = [
  {
    path: '/ecommerce/settings/statuses',
    name: 'status',
    component: () => import(/* webpackChunkName: "status" */ '../views/StatusView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Statuses',
          path: '/ecommerce/settings/statuses',
        },
      ],
    },
    children: [],
  },
];

export default Status;
